import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/User/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import DangerBox from 'components/Web_User_Interface/1440p_Series/System/User/DangerBox';
import UserTable from 'components/Web_User_Interface/1440p_Series/System/User/userTable';
import UserPermissionTable from 'components/Web_User_Interface/1440p_Series/System/User/userPermissionTable';
import YoutubeVideoCardSessions from 'components/Web_User_Interface/1440p_Series/System/User/YoutubeVideoCardSessions';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menü // Benutzerverwaltung",
  "path": "/Web_User_Interface/1440p_Serie/System/Benutzer/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Die Weboberfläche Ihrer Kamera bietet Ihnen eine dreistufige Benutzerverwaltung für Benutzer mit unterschiedlichen Zugriffsrechten für Administratoren, Benutzer und Besucher. Sie können die Benutzernamen und zugehörige Kennwörter für alle 3 Stufen im Benutzer-Overlay festlegen. Gäste [guest] haben nur Zugriff auf den Videostream der Kamera, Benutzer [user] können die Kamera zusätzlich noch schwenken und nur der Administrator [administrator] hat Zugriff auf die Konfigurationsmenüs der Kamera.",
  "image": "./WebUI_1440p_SearchThumb_System_User.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_System_User.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='System Menü // Benutzerverwaltung' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Die Weboberfläche Ihrer Kamera bietet Ihnen eine dreistufige Benutzerverwaltung für Benutzer mit unterschiedlichen Zugriffsrechten für Administratoren, Benutzer und Besucher. Sie können die Benutzernamen und zugehörige Kennwörter für alle 3 Stufen im Benutzer-Overlay festlegen. Gäste [guest] haben nur Zugriff auf den Videostream der Kamera, Benutzer [user] können die Kamera zusätzlich noch schwenken und nur der Administrator [administrator] hat Zugriff auf die Konfigurationsmenüs der Kamera.' image='/images/Search/WebUI_1440p_SearchThumb_System_User.png' twitter='/images/Search/WebUI_1440p_SearchThumb_System_User.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/System/User/' locationFR='/fr/Web_User_Interface/1440p_Series/System/User/' crumbLabel="User Management" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "ändern-sie-den-login-bevor-sie-ihre-kamera-freigeben",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#%C3%A4ndern-sie-den-login-bevor-sie-ihre-kamera-freigeben",
        "aria-label": "ändern sie den login bevor sie ihre kamera freigeben permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Ändern Sie den Login bevor Sie Ihre Kamera freigeben`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/8a343c792e312ada1996d41adc8dddf3/024d6/1440p_Settings_System_User.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.60869565217392%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAC40lEQVQ4y22TW28bRRiG8yOQEERJk1wQr9dNYxPbMWuvvbHjw66969mdPWQdo5IUKReAFAqIG0BUlJC2EuKmUsWP4I5ykOCnPWjGceqqXLyanT08+8z3zayVSiWKxSJm6S6Dj3+kd/EL7fOn2GdPaJ09ofnR/+UpnfNrwi9/xXZT3nn7Ld5dX2dra4s1DTQMiqU97j/+jfvP/mF29Sfz67/Jr/5C/vAH0aOXRI9+fy2nVy958PO/NL05O3c22N012N0tsKbsVAzDwHOHyDBgOvEIxi4iGOMNj7GtQ5qNGtZh9Tb16vv0ew69o2OalkPb7lGtHrJmmiZLaBAE5HlOlmVIKYmiiPF4guMc0W63+cCydCyrSaPRYDQcMToe0Wp1aNvdBXDV0A8CDYvjmDAMb4BjOp0OzWbzJi1arRaWZeGOXHx3iNNxsFtdqgcrhgoY3AAVSAihR8/zsG1bA5TVMvV6neFwRCQGdOy2BtbeMPR9kiTRhgoYCsFkMsZ1XZ1Bv0+/32cwGOhRvT/x+jh2m57jUK/VXwELhYKGzOdzDVXXIkqIk5QsTYljSRRnpNkJSRxre5Vhv0e3Y3N81KFWXQJNE8Mo4E8j0tmHJIkynBLGJ2T5KVmWatsoycnymX6uaixEyEy4DLoOXadHrdZY7ENzCQyEBqx2erUEUkZ6vrgnEWGI9BzqB2UqlQPulvYWhsvGLLeN+kAtR1ksu706X9gJ/cN79/ZZ16fkjs5tDVWm04BZnpOfpNpGQZZGkZTIOCFNM1JVQyGIpaRSqbC5ucnOzg7b29uvgGaxyNifEsSn+HJGKBPCKEbGqV5yEgVEgct04jIKBcNQ4EtJuVxmY2NDw26Bpllk1zA5S8c8/9zn+eWYT+Y+k+nitISRJL74BvnZTyTnX/GdN+Gx53PpT9nb39eGbwDfM0zOU5cXX0x48XDCpwoYqHoJRBghL74lvXxG+uBrvvd8rn3BQwUsl18D/gdHVSnlv3qK5QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8a343c792e312ada1996d41adc8dddf3/e4706/1440p_Settings_System_User.avif 230w", "/de/static/8a343c792e312ada1996d41adc8dddf3/d1af7/1440p_Settings_System_User.avif 460w", "/de/static/8a343c792e312ada1996d41adc8dddf3/7f308/1440p_Settings_System_User.avif 920w", "/de/static/8a343c792e312ada1996d41adc8dddf3/7733b/1440p_Settings_System_User.avif 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/8a343c792e312ada1996d41adc8dddf3/a0b58/1440p_Settings_System_User.webp 230w", "/de/static/8a343c792e312ada1996d41adc8dddf3/bc10c/1440p_Settings_System_User.webp 460w", "/de/static/8a343c792e312ada1996d41adc8dddf3/966d8/1440p_Settings_System_User.webp 920w", "/de/static/8a343c792e312ada1996d41adc8dddf3/85db8/1440p_Settings_System_User.webp 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8a343c792e312ada1996d41adc8dddf3/81c8e/1440p_Settings_System_User.png 230w", "/de/static/8a343c792e312ada1996d41adc8dddf3/08a84/1440p_Settings_System_User.png 460w", "/de/static/8a343c792e312ada1996d41adc8dddf3/c0255/1440p_Settings_System_User.png 920w", "/de/static/8a343c792e312ada1996d41adc8dddf3/024d6/1440p_Settings_System_User.png 961w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/8a343c792e312ada1996d41adc8dddf3/c0255/1440p_Settings_System_User.png",
              "alt": "Web User Interface - 1440p Series - System User",
              "title": "Web User Interface - 1440p Series - System User",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <UserTable mdxType="UserTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <DangerBox mdxType="DangerBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p>{`Die Weboberfläche Ihrer Kamera bietet Ihnen standardmäßig eine dreistufige Benutzerverwaltung für Benutzer mit unterschiedlichen Zugriffsrechten für Administratoren, Benutzer und Besucher. Sie können die Benutzernamen und zugehörige Kennwörter für alle 3 Stufen im Benutzer-Overlay festlegen. Gäste `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`guest`}</code>{` haben nur Zugriff auf den Videostream der Kamera, Benutzer `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`operator`}</code>{` können die Kamera zusätzlich noch schwenken und nur der Administrator `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`admin`}</code>{` hat Zugriff auf die Konfigurationsmenüs der Kamera.`}</p>
    <p>{`Sie können neben den 3 Standardbenutzern weitere Benutzer hinzufügen, indem Sie auf das grüne Plus-Symbol oben rechts im Menü klicken. Sie können auch zwei der Standardanmeldungen bearbeiten - `}<strong parentName="p">{`das Administratorkonto kann jedoch nicht bearbeitet oder gelöscht werden`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Für die `}<em parentName="p">{`2-Faktor-Authentifizierung`}</em>{` (`}<strong parentName="p">{`2fa`}</strong>{`) und `}<em parentName="p">{`Passwortwiederherstellung`}</em>{` lesen Sie bitte unsere `}<a parentName="p" {...{
          "href": "/de/Frequently_Asked_Question/WQHD_2fa_Authentication"
        }}>{`FAQ zu 2fa`}</a>{`.`}</p>
    </blockquote>
    <EuiSpacer mdxType="EuiSpacer" />
    <YoutubeVideoCardSessions mdxType="YoutubeVideoCardSessions" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "zugriffsbeschränkungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#zugriffsbeschr%C3%A4nkungen",
        "aria-label": "zugriffsbeschränkungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Zugriffsbeschränkungen`}</h2>
    <ul>
      <li parentName="ul">{`Siehe auch: `}<a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/WQHD_User_Permissions/"
        }}>{`FAQ :: Ist es möglich, auf das Live-Video zuzugreifen, ohne Zugriff auf die Web-Benutzeroberfläche zu haben?`}</a></li>
    </ul>
    <p>{`Wie in der obigen Abbildung zu sehen ist, können Sie für diese Konten aus einer Vielzahl von Benutzerrechten wählen:`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <UserPermissionTable mdxType="UserPermissionTable" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      